import useVendorReportLink from './useVendorReportLink';

export { useVendorReportLink };
